import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { LabelService } from 'src/app/_services/label.service';
import { LabelDuzenleComponent } from '../label-duzenle/label-duzenle.component';
import { EtiketDuzenleComponent } from './etiket-duzenle/etiket-duzenle.component';
import { MobilDuzenleComponent } from './mobil-duzenle/mobil-duzenle.component';

@Component({
  selector: 'app-labeldetail',
  templateUrl: './labeldetail.component.html',
  styleUrls: ['./labeldetail.component.css']
})
export class LabeldetailComponent implements OnInit {
id:any;
label:any;
  constructor(
    private route: ActivatedRoute,
    private labelService:LabelService,
    private toastr: ToastrService,
    private modal: NgbModal
  ) { }

  ngOnInit() {
    this.id = this.route.snapshot.paramMap.get('id')!;

    this.getLabel();
   
  }

  getLabel(){
    this.labelService.getLabelbyId(this.id).subscribe(res=>{this.label=res;console.log(res);});
  }


  onayla(){
    this.labelService.onayla(this.id).subscribe(res=>{
      this.label=res;
      this.toastr.success('','Etiket onaylandı!');
    },err=>{
      this.toastr.error('','Etiket onayı sırasında hata oluştu!');
    });
  }

    kaldir(){
    this.labelService.kaldir(this.id).subscribe(res=>{
      this.label=res;
      this.toastr.success('','Etiket onayı kaldırıldı!');
    },err=>{
      this.toastr.error('','Etiket onayı sırasında hata oluştu!');
    });
  }

   allkaldir(){
    this.labelService.allkaldir(this.id).subscribe(res=>{
      this.toastr.success('','Etiket onayı kaldırıldı!');
    },err=>{
      this.toastr.error('','Etiket onayı sırasında hata oluştu!');
    });
  }

  allonayla(){
     this.labelService.allonayla(this.id).subscribe(res=>{
      this.toastr.success('','Etiket onaylandı!');
    },err=>{
      this.toastr.error('','Etiket onayı sırasında hata oluştu!');
    });
  }

  openEditModal(){
    const modalref=  this.modal.open(LabelDuzenleComponent, { size: 'lg' });
    modalref.componentInstance.label=this.label;
    modalref.result.then((result)=>{
      this.getLabel();
    });
    }

    etiketonay(){
          const modalref=  this.modal.open(EtiketDuzenleComponent, { size: 'lg' });
    modalref.componentInstance.label=this.label;
    modalref.result.then((result)=>{
      this.getLabel();
    });
    }

    mobiletiketonay(){
       const modalref=  this.modal.open(MobilDuzenleComponent, { size: 'lg' });
    modalref.componentInstance.label=this.label;
    modalref.result.then((result)=>{
      this.getLabel();
    });
    }
}
